import { Tween } from '../generated/index.gen';
const TweenHelper = {
    Move(move) {
        return {
            $case: 'move',
            move
        };
    },
    Rotate(rotate) {
        return {
            $case: 'rotate',
            rotate
        };
    },
    Scale(scale) {
        return {
            $case: 'scale',
            scale
        };
    }
};
export function defineTweenComponent(engine) {
    const theComponent = Tween(engine);
    return {
        ...theComponent,
        Mode: TweenHelper
    };
}
